import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type EditionContractPublisherViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  publisherValue: { displayId: string; id: string } | null;
  percentageValue?: { displayId: string; id: string } | null;
  percentage: number;
};

export const EditionContractPublisherViewForm: React.FC<EditionContractPublisherViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      publisherValue,
      percentage = 0,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupEditionContractPublisherLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.EditionContractPublisherPublisherLabel}
                  selectedValue={langStore.displayIdByLang(
                    publisherValue?.displayId
                  )}
                />
                <ShowNumber
                  value={percentage}
                  label={langStore.EditionContractPublisherPercentageLabel}
                  decimalScale={2}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
